import { ref } from "vue";
import { checkNotifications } from "@/Groups/Notifications/private/api/checkNewNotifications";
import { useUserAuth } from "@/Groups/Notifications/private/imports/userStoreData";
import store from '@shared/store/index';

export function useNotificationPoller() {
  const isActive = ref(false);
  const { hasPaidAccount } = useUserAuth();
  let intervalId = null;

  // Проверка новых уведомлений
  const fetchNotifications = async () => {
    if (!hasPaidAccount.value) return;
    try {
      const data = await checkNotifications();
      store.dispatch('Notifications/updateNewNotifications', {
        avatars: data.avatar_urls,
        count: data.notifications_count,
      })
    } catch (error) {
      console.error("Ошибка при проверке уведомлений:", error);
    }
  };

  // Запустить опрос
  const startPolling = () => {
    if (isActive.value) return;
    isActive.value = true;
    fetchNotifications();
    intervalId = setInterval(fetchNotifications, 1000 * 60 * 2);
    document.addEventListener("visibilitychange", handleVisibilityChange);
  };

  // Остановить опрос
  const stopPolling = () => {
    if (!isActive.value) return;
    clearInterval(intervalId);
    isActive.value = false;
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };

  // Обработчик фокуса вкладки
  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      fetchNotifications();
    }
  };

  return {
    startPolling,
    stopPolling,
    isActive,
  };
}